export default __webpack_public_path__ + "static/media/student-orange.f7874d0f.svg";